<template>
  <!-- 接单 -->
  <div class="create-order">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      class="rule-content"
    >
      <titleBlock class="title_bar" title="仓订单接单配置">
        <div class="text-wrapper">
          <!-- <span class="text1">仓订单接单配置</span> -->
          <span class="text2">开启后将仓订单将自动接单</span>
        </div>
        <el-switch
          v-model="form.orderAcceptConfig.warehouseAutoAccept"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
      </titleBlock>
      <titleBlock class="title_bar" title="运营项目卡控">
        <div class="text-wrapper">
          <span class="text2">开启配置后，订单接单将强校验运营项目，不允许为空</span>
        </div>
        <el-switch
          v-model="form.orderAcceptConfig.projectCheck"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
      </titleBlock>
    </el-form>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { processingSelectData } from '@/utils/index';
import titleBlock from '../assembly/titleBlock.vue';
import {
  TIME_UNIT,
  RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE,
  OVERTIME_TYPE,
  CONDITION_TYPE_MAP,
  CONDITION_KIND,
  receiveOrderTimeoutNotification,
  NOTIFY_TIME_TYPE,
} from './const';

export default {
  components: { titleBlock },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      receiveOrderTimeoutNotification,
      OVERTIME_TYPE,
      CONDITION_KIND,
      module: 'DEAL',
      rules: {
        'orderAcceptConfig.warehouseAutoAccept': [
          { required: true, message: '请选择仓订单接单配置', trigger: 'change' },
        ],
        'orderAcceptConfig.projectCheck': [
          { required: true, message: '请选择运营项目卡控', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
    conditionType() {
      const { ASSIGNED, ROOT_CUSTOMER_NAME } = CONDITION_TYPE_MAP;
      return processingSelectData({ ASSIGNED, ROOT_CUSTOMER_NAME });
    },
    notifyTimeType() {
      return processingSelectData(NOTIFY_TIME_TYPE);
    },
    notifyTimeUnit() {
      return processingSelectData({ ...TIME_UNIT, MINUTE: '分钟' });
    },
  },
  watch: {
    // 'form.AUTO_DEAL.flag': {
    //   handler(flag) {
    //     if (flag && !this.form.AUTO_DEAL_CONDITION.condition.length) {
    //       this.addOrCondition();
    //     }
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    async valiForm() {
      await this.$refs.form.validate();
      return {
        form: cloneDeep(this.form),
      };
    },
    clearValidate(prop) {
      this.$refs.form.clearValidate(prop);
    },
    addOrCondition() {
      this.$emit('addOrCondition', this.module, 'AUTO_DEAL_CONDITION');
    },
    addAdnCondition(index) {
      this.$emit('addAdnCondition', index, this.module, 'AUTO_DEAL_CONDITION');
    },
    Delete(value) {
      this.$emit('delete', value, this.module, 'AUTO_DEAL_CONDITION');
    },
    handleOrDelete(value) {
      this.$emit('OrDelete', value, this.module, 'AUTO_DEAL_CONDITION');
    },
  },
};
</script>

<style lang="scss" scoped>
.create-order{
  box-sizing: border-box;
  padding:0 24px 24px;
  padding-bottom: 40px;
  ::v-deep .title_bar{
    border-bottom: 1px solid #D9DBDE;
  }
  .title-block{
    padding-top:24px;
  }
  ::v-deep .el-switch{
    margin:8px 0 12px;
  }
  .text-wrapper{
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
      margin-right: 8px;
    }
    .text2{
      font-size: 13px;
      color:#808792;
      // margin-left:8px;
    }
  }
  .new-flex{
    display:flex;
    flex-wrap:wrap;
    .second-title{
      color:#404B5C;
      margin-bottom:8px;
      width:100%;
    }
    ::v-deep .el-form-item{
      margin-right:16px;
      .el-select{
        margin-right:8px;
      }
      .el-input{
        margin-right:8px;
      }
    }
  }
  .required:before{
    content:'*';
    color:red;
  }
}
.marginBottom{
  margin:8px 0 24px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
</style>
